/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import NavBar from "../../../components/NavBar/NavBar";
import SalesTabV2 from "./Chunks/SalesTabV2";
import ImagesTabV2 from "./Chunks/ImagesTabV2";
import ChangeQAStatus from "./Chunks/ChangeQAStatus";
import ImageViewDialogV2 from "./Chunks/ImageViewDialogV2";
import { IsEmpty } from "../../../utils/helper";
import {
  HttpRequest,
  HttpRequestFileDownload,
} from "../../../utils/httpRequests";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import BottomBar from "../../../components/BottomBar/BottomBar";

const useStyles = (theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 0, 2),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  cardContentDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: 70,
    marginBottom: 10,
    overFlow: "hidden",
  },
  contentContainer: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
  },
  contentContainerSM: {
    alignItems: "center",
    textAlign: "center",
    width: "45%",
    marginLeft: 10,
    marginRight: 5,
  },
});

class C11PrintingQADashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ordersData: [],
      ordersDataLoading: false,
      salesData: [],
      salesDataLoading: false,
      imagesData: [],
      imagesDataLoading: false,
      barcodeData: [],
      barcodeDataLoading: false,
      selectedOrder: {},
      selectedSalesData: {},

      selectedCheckValue: -1,
      selectedSale: {},
      selectedQAItem: {},

      isDownloadImages: false,
      isDownloadPdfImages: false,

      isLoading: false,
      isReload: true,

      openChangeStatusDialog: false,
      selectionData: [],
      selectionDataError: "",

      statusData: [],
      statusDataLoading: false,

      status: "",
      statusError: "",

      remarks: "",
      remarksError: "",

      qaStatus: "",
      qaStatusError: "",

      qaRemarks: 1,
      qaRemarksError: "",

      filterStatus: 0,
      filterStatusError: "",

      selectImageObject: {},
      selectImageIndex: 0,
      isOpenImageViewer: false,

      isNextArrowDisabled: true,
      isBackArrowDisabled: true,

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      // remarksData :[],
      remarksNoData: [],
      remarksYesData: [],

      onScanTrayBarCodeLoading: false,

      traybarCode: "",
      lastTrayBarCode: "",
    };
  }

  componentDidMount() {
    this.loadQARemarks();
    this.getOrdersData();
    // this.getData(
    //   `/sales/C11SalesOrderStatusView`,
    //   "statusData",
    //   "statusDataLoading"
    // );
  }

  loadQARemarks = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C06CommonQaDashboardRemarksView`;
    let res = await HttpRequest("GET", url, null, "authorizeJson");

    if (res.isSuccess) {
      //alert(res.isSuccess);
      this.setState({
        remarksData: res.data,
      });
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    // this.setState({
    //    [loadingName]: false,
    // });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  getData = async (
    endpoint = "",
    stateName = "",
    loadingStateName = "",
    isQACheckReload = false
  ) => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
    });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      }
    }

    switch (stateName) {
      case "salesData":
        if (resData && resData[0]) {
          this.getImagesAgainstOrderIdAndProductId(
            resData[0],
            resData[0].orderId,
            resData[0].productId,
            resData[0].id
          );
        }
        break;
      case "ordersData":
        if (!isQACheckReload) {
          this.setState({
            selectedOrder: {},
            imagesData: [],
            selectedSalesData: {},
            salesData: [],
          });
        } else {
          let order = resData.find((order) => {
            return order.id == this.state.selectedOrder.id;
          });
          this.getOrderId(order, isQACheckReload);
        }
        break;
      case "barcodeData":
        if (res.isSuccess && resData.length > 0) {
          localStorage.setItem("ckBarcodeData", JSON.stringify(resData[0]));
          this.setState({
            barcodeData: resData[0],
          });
          window.open("#/print-barcode");
        }
        break;
      default:
        break;
    }

    this.setState({
      [stateName]: resData,
      [loadingStateName]: false,
    });
  };

  getOrdersData = async (status = "", isQACheckReload = false) => {
    const statusValue = status !== "" ? status : this.state.filterStatus;
    this.getData(
      `/sales/C11SalesOrderItemsViewV4?statusId=${statusValue}`,
      "ordersData",
      "ordersDataLoading",
      isQACheckReload
    );
  };

  getSalesData = async (orderId) => {
    this.getData(
      `/sales/C11SalesOrderItemsDetailView?id=${orderId}`,
      "salesData",
      "salesDataLoading"
    );
  };

  getImagesData = async (orderId, productId, jobId) => {
    this.getData(
      `/sales/C11SalesOrderItemsImagesViewV2?orderId=${orderId}&productId=${productId}&orderItemId=${jobId}`,
      "imagesData",
      "imagesDataLoading"
    );
  };

  printBarcode = async () => {
    this.getData(
      `/sales/C11SalesOrderItemsImagesBarcodeViewV2?orderId=${this.state.selectedOrder.orderId}&productId=${this.state.selectedSalesData.productId}`,
      "barcodeData",
      "barcodeDataLoading"
    );
  };

  // toggleChangeQAStatusDialog = (isChecked, sale, qaItem) => {
  //   const { openChangeStatusDialog } = this.state;
  //   this.setState({
  //     openChangeStatusDialog: !openChangeStatusDialog,
  //     selectedSale: sale,
  //     selectedCheckValue: isChecked,
  //     selectedQAItem: qaItem,
  //   });
  // };

  toggleChangeQAStatusDialog = (
    isChecked,
    sale,
    qaItem,
    remarks,
    // eslint-disable-next-line no-unused-vars
    qaRemarks
  ) => {
    const { openChangeStatusDialog } = this.state;

    this.setState({
      openChangeStatusDialog: !openChangeStatusDialog,
      selectedSale: sale,
      selectedCheckValue: isChecked,
      selectedQAItem: qaItem,
      remarksNoData: remarks,
      qaRemarks: remarks[0].id,
    });
  };

  toggleChangeStatusDialog = (data) => {
    const { openChangeStatusDialog } = this.state;
    this.setState({
      openChangeStatusDialog: !openChangeStatusDialog,
      selectedData: data,
    });
  };

  onCheckClick = (e, row = {}) => {
    const { checked } = e.target;
    let { ordersData } = this.state;
    const studentIndex = ordersData.findIndex(
      (item) => item.orderId === row.orderId
    );
    ordersData[studentIndex].isChecked = checked;
    this.setState({
      ordersData,
      selectionDataError: "",
    });
  };

  getOrderId = (order, isQACheckReload = false) => {
    this.getSalesData(order.id);
    if (!isQACheckReload) {
      this.setState({
        selectedOrder: order,
        imagesData: [],
        selectedSalesData: {},
      });
    } else {
      this.setState({
        selectedOrder: order,
      });
    }
  };

  updateSelectedOrderData = (selectedOrder) => {
    let orders = this.state.ordersData.filter((order) => {
      return order.id === selectedOrder.id;
    });
    this.setState({
      selectedOrder: orders[0],
    });
  };

  getImagesAgainstOrderIdAndProductId = (sale, orderId, productId, jobId) => {
    this.getImagesData(orderId, productId, jobId);
    this.setState({
      selectedSalesData: sale,
    });
  };

  onFocusOutTrayBarCodeField = (e, lastTrayBarCode) => {
    if (this.state.traybarCode || lastTrayBarCode) {
      this.onScanTray(lastTrayBarCode);
    }
  };

  onScanTray = async (lastTrayBarCode) => {
    this.setState({
      onScanTrayBarCodeLoading: true,
    });

    let resData = [];

    const itemAssignedTrayBarCode = this.state.traybarCode || lastTrayBarCode;

    const data = new FormData();

    data.append("trayBarCode", itemAssignedTrayBarCode);
    const endpoint = `/sales/C11SalesOrderItemsDetailWithTrayBarCodeView?trayBarCode=${itemAssignedTrayBarCode}`;
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );

    if (res.isSuccess) {
      resData = res.data || [];
      if (!IsEmpty(resData)) {
        this.setState({
          selectedOrder: resData[0],
          salesData: resData,
        });
        this.getImagesAgainstOrderIdAndProductId(
          resData[0],
          resData[0].orderId,
          resData[0].productId,
          resData[0].id
        );
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      onScanTrayBarCodeLoading: false,
      lastTrayBarCode: itemAssignedTrayBarCode,
      traybarCode: "",
    });
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    switch (name) {
      case "filterStatus":
        this.getOrdersData(value);
        break;
      default:
        break;
    }
    this.setState({
      [name]: value,
      [errName]: "",
      selectionDataError: "",
    });
  };

  isFormValid = () => {
    let { statusError } = this.state;
    let isValid = true;

    if (!this.state.status) {
      isValid = false;
      statusError = "Please select status";
    } else {
      statusError = "";
    }

    this.setState({
      statusError,
    });

    return isValid;
  };

  onSaveClick = () => {
    if (this.isFormValid()) {
      document.getElementById("btnStatusSubmit").click();
    }
  };

  isQAActivityStatusFormValid = () => {
    let { qaRemarksError } = this.state;
    let isValid = true;

    if (!this.state.qaRemarks) {
      isValid = false;
      qaRemarksError = "Please enter remarks";
    } else {
      qaRemarksError = "";
    }

    this.setState({
      qaRemarksError,
    });

    return isValid;
  };

  changeQAActivity = async () => {
    if (this.isQAActivityStatusFormValid()) {
      this.handleQACheckList(
        this.state.selectedCheckValue,
        this.state.selectedSale,
        this.state.selectedQAItem,
        this.state.qaRemarks
      );
      const { openChangeStatusDialog } = this.state;
      this.setState({
        openChangeStatusDialog: !openChangeStatusDialog,
      });
    }
  };

  changeQAStatus = async () => {
    this.setState({
      isLoading: true,
    });

    const endpoint = `sales/C11SalesOrderSaveStatus`;

    const data = new FormData();

    data.append("orderId", this.state.selectedOrder.orderId);
    data.append("orderItemId", this.state.selectedOrder.id);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/${endpoint}`,
      data,
      "authorize"
    );
    if (res.isSuccess) {
      this.handleSnackbar(true, "Saved", "success");
      this.getData(
        `/sales/C11SalesOrderViewV2?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
      this.setState({
        status: "",
        statusError: "",
        remarks: "",
        remarksError: "",
        lastTrayBarCode: "",
        traybarCode: "",
      });
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      isLoading: false,
    });
  };

  handleOnKeyPressedForImageDilog = (event) => {
    switch (event.key) {
      case "ArrowRight":
        if (!this.state.isNextArrowDisabled) {
          this.onNextArrowClick();
        }
        break;
      case "ArrowLeft":
        if (!this.state.isBackArrowDisabled) {
          this.onBackArrowClick();
        }
        break;
      default:
        break;
    }
  };

  onImageClick = (object) => {
    let { imagesData, isNextArrowDisabled, isBackArrowDisabled } = this.state;
    const currentImageIndex = imagesData.findIndex(
      (item) => item.id == object.id
    );

    if (currentImageIndex != -1) {
      if (currentImageIndex == 0) {
        isBackArrowDisabled = true;
      } else {
        isBackArrowDisabled = false;
      }
      if (currentImageIndex + 1 == imagesData.length) {
        isNextArrowDisabled = true;
      } else {
        isNextArrowDisabled = false;
      }
    }

    window.addEventListener(
      "keydown",
      this.handleOnKeyPressedForImageDilog,
      false
    );

    this.setState({
      selectImageObject: object,
      isOpenImageViewer: true,
      selectImageIndex: currentImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  handleImageViewerToggle = () => {
    const value = this.state.isOpenImageViewer ? false : true;
    this.setState({
      isOpenImageViewer: value,
    });
  };

  handleCloseImageDialog = () => {
    window.removeEventListener("keydown", this.handleOnKeyPressedForImageDilog);
    this.setState({
      isOpenImageViewer: false,
      selectImageIndex: 0,
      selectImageObject: {},
      isBackArrowDisabled: true,
      isNextArrowDisabled: true,
    });
  };

  handleQACheckList = async (isChecked, sale, qaItem, qaRemarks) => {
    if (qaRemarks == "") {
      qaRemarks = 1;
    }
    let qaValue = 0;

    if (isChecked == 1) {
      qaValue = 1;
    } else {
      qaValue = qaItem.id;
    }
    const endpoint = `/sales/C11SalesOrderItemsQaActivityLogsSave?orderId=${this.state.selectedOrder.orderId}&orderItemId=${sale.id}&qaActivityId=${qaValue}&isChecked=${isChecked}&remarks=${qaRemarks}`;

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );

    if (res.isSuccess) {
      this.onFocusOutTrayBarCodeField(null, this.state.lastTrayBarCode);
    }
  };

  downloadFile = async (e, fileName) => {
    e.preventDefault();

    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${fileName}`;

    let result = await HttpRequestFileDownload(
      "GET",
      url,
      "authorizeJson",
      fileName
    );

    if (result.isSuccess) {
      let csvURL = URL.createObjectURL(result.data);
      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", fileName);
      tempLink.click();
    } else {
      if (result.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        alert(result.message);
      }
    }
  };

  handleChangeQAStatusClose = () => {
    const { openChangeStatusDialog } = this.state;
    this.setState({
      openChangeStatusDialog: !openChangeStatusDialog,
      qaStatus: "",
      qaStatusError: "",
      qaRemarks: 1,
      qaRemarksError: "",
    });
  };

  handleChangeStatusClose = () => {
    this.toggleChangeStatusDialog();
    this.setState({
      status: "",
      statusError: "",
      remarks: "",
      remarksError: "",
    });
  };

  onNextArrowClick = () => {
    let {
      imagesData,
      isNextArrowDisabled,
      isBackArrowDisabled,
      selectImageIndex,
      selectImageObject,
    } = this.state;
    let imageObject = selectImageObject;
    let prevImageIndex = selectImageIndex;
    let nextImageIndex = selectImageIndex;

    if (prevImageIndex != -1) {
      nextImageIndex = prevImageIndex + 1;
      if (nextImageIndex == imagesData.length) {
        isNextArrowDisabled = true;
      } else {
        if (nextImageIndex + 1 == imagesData.length) {
          isNextArrowDisabled = true;
        } else {
          isNextArrowDisabled = false;
        }
        isBackArrowDisabled = false;
        imageObject = imagesData[nextImageIndex] || {};
      }
    }

    this.setState({
      selectImageObject: imageObject,
      selectImageIndex: nextImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  onBackArrowClick = () => {
    let {
      imagesData,
      isNextArrowDisabled,
      isBackArrowDisabled,
      selectImageIndex,
      selectImageObject,
    } = this.state;
    let imageObject = selectImageObject;
    let prevImageIndex = selectImageIndex;
    let newImageIndex = selectImageIndex;

    if (prevImageIndex != -1 || prevImageIndex != 0) {
      newImageIndex = prevImageIndex - 1;

      if (newImageIndex == 0) {
        isBackArrowDisabled = true;
      } else {
        isBackArrowDisabled = false;
      }
      isNextArrowDisabled = false;
      imageObject = imagesData[newImageIndex] || {};
    }

    this.setState({
      selectImageObject: imageObject,
      selectImageIndex: newImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  render() {
    const { classes } = this.props;
    let screenHeight = (window.screen.height * 72) / 100;
    return (
      <Fragment>
        <NavBar isAuthorize title="Printing QA Dashboard" />
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <form>
          <input name="statusId" value={this.state.status} type="hidden" />
          <input
            name="orderId"
            value={
              IsEmpty(this.state.selectedOrder)
                ? 0
                : this.state.selectedOrder.orderId
            }
            type="hidden"
          />
          <input name="remarks" value={this.state.remarks} type="hidden" />
          <input
            type="submit"
            style={{ display: "none" }}
            id="btnStatusSubmit"
          />
        </form>
        <ImageViewDialogV2
          downloadFile={(e, fileName) => this.downloadFile(e, fileName)}
          handleClose={() => this.handleCloseImageDialog()}
          open={this.state.isOpenImageViewer}
          data={this.state}
          onNextArrowClick={() => this.onNextArrowClick()}
          onBackArrowClick={() => this.onBackArrowClick()}
        />
        {/* <ChangeStatus
          onSaveClick={() => this.onSaveClick()}
          onHandleChange={this.onHandleChange}
          open={this.state.openChangeStatusDialog}
          state={this.state}
          handleClose={() => this.handleChangeStatusClose()}
          onCheckClick={(e, row) => this.onCheckClick(e, row)}
        /> */}

        <ChangeQAStatus
          onSaveClick={() => this.changeQAActivity()}
          onHandleChange={this.onHandleChange}
          open={this.state.openChangeStatusDialog}
          state={this.state}
          handleClose={() => this.handleChangeQAStatusClose()}
          onCheckClick={(e, row) => this.onCheckClick(e, row)}
        />

        <div style={{ height: screenHeight }} className={classes.tabsContainer}>
          <div className={classes.contentContainerSM}>
            {/* <SalesTabV2
              values={this.state}
              getImagesOrderIdAndProductId={(id, orderId, productId) =>
                this.getImagesAgainstOrderIdAndProductId(id, orderId, productId)
              }
              toggleChangeQAStatusDialog={(isChecked, sale, qaItem) =>
                this.toggleChangeQAStatusDialog(isChecked, sale, qaItem)
              }
              handleQACheckList={(isChecked, sale, qaItem) =>
                this.handleQACheckList(isChecked, sale, qaItem)
              }
              onFocusOutTrayBarCodeField={this.onFocusOutTrayBarCodeField}
              onHandleChange={this.onHandleChange}
            /> */}
            <SalesTabV2
              values={this.state}
              getImagesOrderIdAndProductId={(
                id,
                orderId,
                productId,
                orderItemId
              ) =>
                this.getImagesAgainstOrderIdAndProductId(
                  id,
                  orderId,
                  productId,
                  orderItemId
                )
              }
              toggleChangeQAStatusDialog={(
                isChecked,
                sale,
                qaItem,
                remarks,
                qaRemarks
              ) =>
                this.toggleChangeQAStatusDialog(
                  isChecked,
                  sale,
                  qaItem,
                  remarks,
                  qaRemarks
                )
              }
              handleQACheckList={(isChecked, sale, qaItem, qaRemarks) =>
                this.handleQACheckList(isChecked, sale, qaItem, qaRemarks)
              }
              onFocusOutTrayBarCodeField={this.onFocusOutTrayBarCodeField}
              onHandleChange={this.onHandleChange}
            />
          </div>
          <div className={classes.contentContainer}>
            <ImagesTabV2
              values={this.state}
              downloadPdfImagesData={() => this.downloadPdfImagesData()}
              downloadImagesData={() => this.downloadImagesData()}
              onImageClick={(object) => this.onImageClick(object)}
              printBarcode={() => this.printBarcode()}
            />
          </div>
        </div>

        <BottomBar
          rightButtonDisable={
            IsEmpty(this.state.selectedOrder) ||
            this.state.selectedOrder.isChangeStatusEnable == 0 ||
            this.state.isLoading
          }
          isLoading={this.state.isLoading}
          leftButtonHide
          rightButtonText="Send to Production QA"
          rightButtonAction={() => this.changeQAStatus()}
        />

        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
      </Fragment>
    );
  }
}

C11PrintingQADashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(C11PrintingQADashboard);
